// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 488) return "/dist/js/carousel-slider.js";
	if (chunkId === 282) return "/dist/js/section-info.js";
	if (chunkId === 472) return "/dist/js/burger.js";
	if (chunkId === 694) return "/dist/js/gallery-grid.js";
	if (chunkId === 205) return "/dist/js/google-map.js";
	if (chunkId === 842) return "/dist/js/menu-main.js";
	if (chunkId === 585) return "/dist/js/popup.js";
	// return url for filenames based on template
	return undefined;
};